import { EmbeddedSubmissionConfig as IEmbeddedSubmissionConfig } from 'services/api-service'


export class EmbeddedSubmissionConfig implements IEmbeddedSubmissionConfig {
  constructor(config: IEmbeddedSubmissionConfig) {
    this.headerImage = config.headerImage
    this.siteLink = config.siteLink
    this.turntoHosted = config.turntoHosted
    this.divId = config.divId
  }

  headerImage?: string // img name
  siteLink?: string
  turntoHosted?: boolean
  divId: string
}

let defaultConfig: IEmbeddedSubmissionConfig = {}
export function loadConfig(config: IEmbeddedSubmissionConfig): void {
  defaultConfig = new EmbeddedSubmissionConfig(config)
}
export { defaultConfig as default }
